import { Outlet } from 'react-router-dom'
import { Header } from './components/Header'

export const BasicLayout = () => {
  return <>
    <Header />
    
    <Outlet />
  </>
}